import { getTitle } from 'utils/map/MapMarkersUtils';

const wrapScrollable = (content) =>
  `<div style="max-height:160px;overflow-y:auto;font-size:12px;line-height:1.4">${content}</div>`;

export function buildActivityClusterPopupHtml(dataPoints, translations) {
  const labels = dataPoints.map((p) => p.labels?.[0]).filter(Boolean);
  const header = `<b style="font-size:12px">${translations.wizard.orders.activityCount}: ${dataPoints.length}</b>`;
  return wrapScrollable(`${header}${getTitle(translations, labels)}`);
}

export function buildStopClusterPopupHtml(dataPoints, translations) {
  const sorted = [...dataPoints].sort((a, b) => {
    const aOrder = a.jobOrder ?? a.stopIndex ?? Infinity;
    const bOrder = b.jobOrder ?? b.stopIndex ?? Infinity;
    return aOrder - bOrder;
  });
  const lines = sorted.map((p) => {
    const stopNum = p.jobOrder ?? p.stopIndex;
    const typesObj = (p.types || []).reduce((acc, t) => {
      acc[t] = 1;
      return acc;
    }, {});
    const title = getTitle(translations, p.labels, typesObj, p.highPriority, p.address);
    const label = title || (p.address ? `<div class="labels">${p.address}</div>` : '');
    return stopNum != null ? `<div><b>#${stopNum}</b>${label ? ` ${label}` : ''}</div>` : label;
  });
  return wrapScrollable(lines.join(''));
}

export function buildOrderClusterPopupHtml(dataPoints, translations) {
  const lines = dataPoints.map((p) => {
    const label = p.labels?.join(', ') || p.address || '';
    return label ? `<div>${label}</div>` : '';
  });
  const count = dataPoints.length;
  const header = `<b style="font-size:12px">${translations.wizard.orders.activityCount}: ${count}</b>`;
  return wrapScrollable(`${header}${lines.join('')}`);
}
